<template>
  <b-table 
    :data="usersList" 
    @click="openInfo"
    @page-change="changePage"
    pagination-simple
    per-page="15"
    paginated
    backend-pagination
    :total="totalCount"
    ref="statTable"
    detailed
    :show-detail-icon="false"
  >
    <template slot-scope="props">
      <b-table-column
        label="ID"
        :visible="true"
        field="id"
        :centered="false"
        width="10%"
      >
        <div>{{ props.row.id }}</div>
      </b-table-column>
      <b-table-column
        label="ФИО"
        :visible="true"
        field="surname"
        :centered="false"
        width="90%"
      > 
      <div class="user-name">{{ props.row.surname + ' ' + props.row.name + ' ' + props.row.patronymic }}</div>
        </b-table-column>
    </template>
    <template slot="detail" slot-scope="props">
      <span class="grey">
        <CourseStatisticUserTableDetail :data="detailData" :user="props.row" @openModal="(branchId, userTestAttemptId) => $emit('openModal', branchId, userTestAttemptId)" />
      </span>
    </template>
  </b-table>
</template>
<script>
import CourseStatisticUserTableDetail from '@/components/admin/all-courses/CourseStatisticUserTableDetail.vue';

export default({
  name: 'CourseStatisticUsersTable',
  components: { CourseStatisticUserTableDetail },
  props: {
    usersList: {
      default: () => [],
      type: Array
    },
    totalCount: {
      default: () => 0,
      type: Number
    },
    currentUserStatistic: {
      default: () => {},
      type: Object
    },
    currentUserStatisticStage: {
      default: () => {},
      type: Object
    },
    search: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      openedRow: {}
    }
  },
  watch: {
    'search.stage_id': function(newVal, prevVal) {
      if (newVal === prevVal) {
        return 
      }
      if (this.openedRow) {
        this.$refs.statTable.toggleDetails(this.openedRow)
        this.openedRow = {};
      }
    }
  },
  computed: {
    detailData() {
      if (this.search.stage_id) {
        return this.currentUserStatisticStage;
      }
      return this.currentUserStatistic;
    }
  },
  methods: {
    changePage(val) {
      this.$emit('changePage', val)
    },
    openInfo(row) {
      if (row != this.openedRow) {
        this.$emit('loadUser', row.id)
        this.$refs.statTable.toggleDetails(this.openedRow)
        this.$refs.statTable.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.statTable.toggleDetails(row)
      this.openedRow = {}

    },

  }
})
</script>
